import {UserRankModificationDomain} from "../../domain/user/UserRankModificationDomain"
import {UserId} from "../../id/user/UserId"
import {UserRankId} from "../../id/user/UserRankId"
import {UserRankModificationId} from "../../id/user/UserRankModificationId"
import {ValueObject} from "ts-protocol-extension"

/**
 * 사용자 랭크 수정 이력
 */
export class UserRankModificationValueObject implements ValueObject, UserRankModificationDomain {
    /**
     * 기본키
     */
    id: UserRankModificationId
    /**
     * 수정자 ID
     */
    creatorId: UserId
    /**
     * 사용자 랭크 ID
     */
    userRankId: UserRankId
    /**
     * 이름
     */
    name: string
    /**
     * 백분위
     */
    percentile?: number
    /**
     * 고정
     */
    fixed?: number
    /**
     * 적용 우선 순위
     */
    applyOrder: number
    /**
     * 보상 루나
     */
    rewardAssetLunarAmount: number
    /**
     * 보상 솔라
     */
    rewardAssetSolarAmount: number
    /**
     * 보상 스타
     */
    rewardAssetStarAmount: number
    /**
     * 수정일
     */
    createdAt: Date

    constructor(o: Record<keyof UserRankModificationDomain, any>) {
        this.id = BigInt(o.id)
        this.creatorId = BigInt(o.creatorId)
        this.userRankId = BigInt(o.userRankId)
        this.name = String(o.name)
        if (o.percentile !== undefined && o.percentile !== null) {
            this.percentile = Number(o.percentile)
        }
        if (o.fixed !== undefined && o.fixed !== null) {
            this.fixed = Number(o.fixed)
        }
        this.applyOrder = Number(o.applyOrder)
        this.rewardAssetLunarAmount = Number(o.rewardAssetLunarAmount)
        this.rewardAssetSolarAmount = Number(o.rewardAssetSolarAmount)
        this.rewardAssetStarAmount = Number(o.rewardAssetStarAmount)
        this.createdAt = new Date(o.createdAt)
    }
}
